import React, { useState, useEffect, useCallback } from "react";
import { api } from "../../services/api.js";
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer";
import Swal from "sweetalert2";
import { FaCalendarDays, FaCakeCandles, FaUmbrellaBeach, FaClock } from 'react-icons/fa6';
import "./escala.css";

function LoadingModal({ show, message }) {
  if (!show) return null;
  return (
    <div className="loading-modal-overlay">
      <div className="loading-modal-content">
        <div
          className="spinner-border text-danger"
          role="status"
          style={{ width: "3rem", height: "3rem" }}
        >
          <span className="visually-hidden">Carregando...</span>
        </div>
        <div style={{ marginTop: 15, fontSize: 16, fontWeight: 600, color: '#2c3e50' }}>{message}</div>
      </div>
      <style>{`
        .loading-modal-overlay {
          position: fixed;
          top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(0,0,0,0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1050;
          backdrop-filter: blur(4px);
        }
        .loading-modal-content {
          background: white;
          padding: 25px 40px;
          border-radius: 16px;
          display: flex;
          flex-direction: column;
          align-items: center;
          box-shadow: 0 10px 30px rgba(0,0,0,0.2);
        }
      `}</style>
    </div>
  );
}

function Escala() {
  const hoje = new Date();
  const mesAtual = String(hoje.getMonth() + 1).padStart(2, "0");
  const anoAtual = hoje.getFullYear();
  const [mesano, setMesAno] = useState(mesAtual + String(anoAtual));
  const [escala, setEscala] = useState([]);
  const [loading, setLoading] = useState(false);
  const chapa = localStorage.getItem("chapa");

  const carregarEscala = useCallback(() => {
    if (!chapa) return;
    setLoading(true);
    api
      .get(`/ponto/${chapa}/escala?mes=${mesano}`)
      .then((res) => {
        setLoading(false);
        if (!res.data || res.data.length === 0) {
          Swal.fire({
            icon: "warning",
            title: "Nenhum dado encontrado",
            text: "Não foi encontrada escala para este período.",
            confirmButtonColor: "#8b0000"
          });
          setEscala([]);
        } else {
          setEscala(res.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Erro ao carregar",
          text: "Não foi possível carregar a escala.",
          confirmButtonColor: "#8b0000"
        });
        console.log(err);
      });
  }, [chapa, mesano]);

  useEffect(() => {
    carregarEscala();
  }, [carregarEscala]);

  function handleMesAno(value) {
    if (!value) return;
    setMesAno(value.substring(5, 7) + value.substring(0, 4));
  }

  function gerarDiasMes() {
    const mes = parseInt(mesano.substring(0, 2), 10) - 1;
    const ano = parseInt(mesano.substring(2), 10);
    const primeiroDia = new Date(ano, mes, 1);
    const ultimoDia = new Date(ano, mes + 1, 0);
    const dias = [];

    for (let i = 0; i < primeiroDia.getDay(); i++) {
      dias.push({ vazio: true });
    }

    const nomesDiasCompletos = ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"];
    const nomesDiasAbrevs = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];

    for (let d = 1; d <= ultimoDia.getDate(); d++) {
      const dataObj = new Date(ano, mes, d);
      const dataStr = dataObj.toISOString().split("T")[0];
      const info = escala.find((e) => e.data.startsWith(dataStr));
      
      const diaSemana = nomesDiasCompletos[dataObj.getDay()];
      const diaSemanaAbrev = nomesDiasAbrevs[dataObj.getDay()];

      dias.push({ dia: d, diaSemana, diaSemanaAbrev, info });
    }

    while (dias.length % 7 !== 0) {
      dias.push({ vazio: true });
    }

    return dias;
  }

  const dias = gerarDiasMes();
  const diasValidos = dias.filter((d) => !d.vazio);

  const horariosFixos = escala.filter((e) => e.tipo === "F");
  const horariosUnicos = [
    ...new Map(
      escala.filter((e) => e.tipo === "S").map((e) => [e.codigo, e])
    ).values(),
  ];
  const aniversario = escala.find((e) => e.tipo === "A");
  const ferias = escala.find((e) => e.tipo === "X");

  return (
    <div className="bg-light min-vh-100" style={{ paddingTop: '80px', paddingBottom: '40px' }}>
      <Menu modulo="ARBOR" />

      <div 
        className="container-fluid py-3 px-2 px-md-5"
        style={{ maxWidth: '1280px', margin: '0 auto' }}
      >
        {/* Cabeçalho */}
        <div className="d-flex align-items-center justify-content-between mb-4 flex-wrap gap-2">
          <div>
            <h4 className="fw-bold m-0 d-flex align-items-center text-dark">
              <FaCalendarDays className="me-2 text-danger" />
              Minha Escala de Trabalho
            </h4>
            <small className="text-muted">Consulte sua jornada, folgas e substituições</small>
          </div>

          <div className="bg-white p-2 rounded-3 border shadow-sm">
            <input
              type="month"
              className="form-control border-0 fw-bold text-danger-gradient"
              value={`${mesano.substring(2)}-${mesano.substring(0, 2)}`}
              onChange={(e) => handleMesAno(e.target.value)}
            />
          </div>
        </div>

        {/* Card da Escala */}
        <div className="card border-0 shadow-sm rounded-4 overflow-hidden bg-white mb-4">
          <div className="card-body p-2 p-md-4">
            
            {/* 🖥️ VISÃO DESKTOP (Tabela Calendário Tradicional) */}
            <div className="d-none d-md-block table-responsive p-0">
              <table className="table table-bordered calendario-grid m-0">
                <thead>
                  <tr className="text-uppercase text-muted extra-small">
                    <th>Dom</th>
                    <th>Seg</th>
                    <th>Ter</th>
                    <th>Qua</th>
                    <th>Qui</th>
                    <th>Sex</th>
                    <th>Sáb</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.from({ length: dias.length / 7 }, (_, i) => (
                    <tr key={i}>
                      {dias.slice(i * 7, i * 7 + 7).map((d, j) => {
                        if (d.vazio) return <td key={j} className="dia-vazio"></td>;
                        const { dia, diaSemanaAbrev, info } = d;
                        let classe = "dia-trabalho-normal"; // Vermelho bem clarinho por padrão (dia trabalhado)
                        let extra = info?.codigo || (horariosFixos[0]?.codigo ?? "");

                        if (info) {
                          switch (info.tipo) {
                            case "F":
                              classe = "dia-folga-verde"; // Verde clarinho para folga/descanso
                              extra = "FOLGA";
                              break;
                            case "A":
                              classe = "dia-aniversario";
                              extra = "🎂";
                              break;
                            case "S":
                              classe = "dia-substituicao"; // Substituto
                              extra = info.codigo;
                              break;
                            case "X":
                              classe = "dia-ferias";
                              extra = "🏖️";
                              break;
                            default:
                              classe = "dia-trabalho-normal";
                          }
                        }

                        return (
                          <td key={j} className={`dia-cell ${classe}`}>
                            <div className="dia-header-box">
                              <span className="num-dia">{String(dia).padStart(2, '0')}</span>
                              <span className="nome-dia-abrev">{diaSemanaAbrev}</span>
                            </div>

                            {extra && (
                              <div className="circle-codigo-wrapper mt-1">
                                <span className={`circle-codigo ${extra === 'FOLGA' ? 'circle-folga' : ''}`}>
                                  {extra}
                                </span>
                              </div>
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* 📱 VISÃO MOBILE (Lista de Dias em Cards) */}
            <div className="d-md-none p-1">
              {diasValidos.map((d, i) => {
                const { dia, diaSemana, info } = d;
                let classeCard = "card-trabalho-mobile";
                let textoStatus = "Trabalho Normal";
                let codCodigo = info?.codigo || (horariosFixos[0]?.codigo ?? "");

                if (info) {
                  switch (info.tipo) {
                    case "F":
                      classeCard = "card-folga-mobile";
                      textoStatus = "Folga / Descanso";
                      codCodigo = "FOLGA";
                      break;
                    case "A":
                      classeCard = "card-aniversario-mobile";
                      textoStatus = "🎂 Aniversário";
                      break;
                    case "S":
                      classeCard = "card-substituto-mobile";
                      textoStatus = "Substituição";
                      break;
                    case "X":
                      classeCard = "card-ferias-mobile";
                      textoStatus = "🏖️ Férias";
                      break;
                    default:
                      break;
                  }
                }

                return (
                  <div key={i} className={`p-3 mb-2 rounded-3 shadow-sm d-flex justify-content-between align-items-center ${classeCard}`}>
                    <div>
                      <div className="d-flex align-items-center gap-2">
                        <span className="fw-bold fs-5 text-dark">
                          Dia {String(dia).padStart(2, '0')}
                        </span>
                        <span className="small text-muted fw-semibold">
                          ({diaSemana})
                        </span>
                      </div>
                      <small className="text-secondary d-block mt-0.5 fw-medium">
                        {textoStatus}
                      </small>
                    </div>

                    {codCodigo && (
                      <span className="circle-codigo circle-codigo-mobile">
                        {codCodigo}
                      </span>
                    )}
                  </div>
                );
              })}
            </div>

          </div>
        </div>

        {/* Legenda de Horários */}
        <div className="card border-0 shadow-sm rounded-4 bg-white p-3 p-md-4">
          <h6 className="fw-bold text-secondary mb-3 d-flex align-items-center">
            <FaClock className="me-2 text-danger" /> Legenda de Horários
          </h6>
          <div className="row g-3">
            <div className="col-12 col-md-6">
              <div className="p-2.5 rounded-3 bg-light border d-flex align-items-center">
                <span className="badge-legend badge-trabalho me-2">Trabalho</span>
                <div className="small">
                  <strong>Dia de Trabalho:</strong> Fundo Vermelho Clarinho
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6">
              <div className="p-2.5 rounded-3 bg-light border d-flex align-items-center">
                <span className="badge-legend badge-folga me-2">Folga</span>
                <div className="small">
                  <strong>Dia de Folga:</strong> Fundo Verde Clarinho
                </div>
              </div>
            </div>

            {horariosFixos.length > 0 && (
              <div className="col-12 col-md-6">
                <div className="p-2.5 rounded-3 bg-light border d-flex align-items-center">
                  <span className="badge-legend badge-normal me-2">Horário</span>
                  <div className="small">
                    <strong>{horariosFixos[0].codigo}:</strong> {horariosFixos[0].descricao}
                  </div>
                </div>
              </div>
            )}

            {horariosUnicos.map((h) => (
              <div key={h.codigo} className="col-12 col-md-6">
                <div className="p-2.5 rounded-3 bg-light border d-flex align-items-center">
                  <span className="badge-legend badge-substituto me-2">Subst.</span>
                  <div className="small">
                    <strong>{h.codigo}:</strong> {h.descricao}
                  </div>
                </div>
              </div>
            ))}

            {aniversario && (
              <div className="col-12 col-md-6">
                <div className="p-2.5 rounded-3 bg-light border d-flex align-items-center">
                  <FaCakeCandles className="text-danger me-2 fs-5" />
                  <span className="small fw-semibold text-dark">🎂 Seu aniversário</span>
                </div>
              </div>
            )}

            {ferias && (
              <div className="col-12 col-md-6">
                <div className="p-2.5 rounded-3 bg-light border d-flex align-items-center">
                  <FaUmbrellaBeach className="text-warning me-2 fs-5" />
                  <span className="small fw-semibold text-dark">🏖️ Período de férias</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />
      <LoadingModal show={loading} message="Carregando escala..." />
    </div>
  );
}

export default Escala;